// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   ProductGrid — 3-column card grid for sidebar-driven views
   ═══════════════════════════════════════════════════════════ */

.pg-wrapper {
  padding: 16px 20px 20px;
}

.pg-section-title {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #2a71ff;
  margin: 0 0 14px;
}

.pg-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* ── Card ────────────────────────────────────────────────── */
.pg-card {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  overflow: hidden;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}
.pg-card:hover {
  border-color: #93c5fd;
  box-shadow: 0 4px 18px rgba(42, 113, 255, 0.1);
}

/* ── Image container (relative so badges can overlay) ── */
.pg-card-img-container {
  position: relative;
  flex-shrink: 0;
}

/* ── Image / placeholder ── */
.pg-card-img-wrap {
  width: 100%;
  height: 80px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #f1f5f9;
}
.pg-card-img-wrap--default {
  /* background is set inline via avatarBg */
}
.pg-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ── Type indicator badges (overlay on image bottom-left) ── */
.pg-card-badges {
  position: absolute;
  bottom: 4px;
  left: 4px;
  right: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  pointer-events: none;
}
.pg-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 5px;
  border-radius: 4px;
  letter-spacing: 0.02em;
  backdrop-filter: blur(4px);
  line-height: 1;
}
.pg-card-badge--scale  { background: rgba(217,119,6,0.88);  color: #fff; }
.pg-card-badge--bundle { background: rgba(99,102,241,0.88);  color: #fff; }
.pg-card-badge--batch  { background: rgba(5,150,105,0.88);   color: #fff; }

/* ── Body ── */
.pg-card-body {
  padding: 8px 10px 6px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}

.pg-card-name {
  font-size: 11.5px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.7em;
}

/* Barcode */
.pg-card-barcode {
  font-size: 10px;
  color: #64748b;
  font-family: "Courier New", Courier, monospace;
  letter-spacing: 0.04em;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Prices */
.pg-card-prices {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  margin-top: 2px;
}

/* MRP with strikethrough — only shown when SP differs */
.pg-card-mrp {
  font-size: 10.5px;
  color: #94a3b8;
  text-decoration: line-through;
}

/* Selling price — highlighted when discounted */
.pg-card-sp {
  font-size: 12px;
  font-weight: 700;
  color: #16a34a;
}

/* Single price (MRP === SP or no SP) — shown without strikethrough */
.pg-card-price-single {
  font-size: 12px;
  font-weight: 700;
  color: #1e40af;
}

/* ── Add to cart button ── */
.pg-card-add-btn {
  width: 100%;
  padding: 8px 6px;
  background: #2a71ff;
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: background 0.15s ease;
  flex-shrink: 0;
  margin-top: auto;
}
.pg-card-add-btn:hover:not(:disabled) {
  background: #1d5fd6;
}
.pg-card-add-btn:disabled {
  background: #93c5fd;
  cursor: default;
}
.pg-card-add-btn--success {
  background: #10b981 !important;
  cursor: default;
}
.pg-card-add-btn--error {
  background: #ef4444 !important;
  cursor: default;
  font-size: 10.5px;
}

/* ── No-inventory card tint ── */
.pg-card.pg-card--no-inv {
  border-color: #fde68a;
  background: #fffdf5;
}
.pg-card.pg-card--no-inv:hover {
  border-color: #fbbf24;
  box-shadow: 0 4px 18px rgba(245, 158, 11, 0.1);
}

/* ── Out-of-stock but eligible to sell (has inward, zero stock) ── */
.pg-card-badge-oos {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  background: #fff7ed;
  color: #c2410c;
  white-space: nowrap;
  width: fit-content;
  border: 1px solid #fed7aa;
}
.dark .pg-card-badge-oos {
  background: #431407;
  color: #fb923c;
  border-color: #7c2d12;
}

/* ── Multi-batch inline badge (card body) ── */
.pg-card-badge-multi-batch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  background: #d1fae5;
  color: #065f46;
  white-space: nowrap;
  width: fit-content;
}
.dark .pg-card-badge-multi-batch {
  background: #064e3b;
  color: #6ee7b7;
}

/* ── No-inventory badge (inside card body) ── */
.pg-card-badge-no-inv {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 9.5px;
  font-weight: 700;
  color: #b45309;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 999px;
  padding: 2px 7px;
  letter-spacing: 0.05em;
  margin-top: 3px;
}

/* ── No-inventory ADD button variant ── */
.pg-card-add-btn.pg-card-add-btn--no-inv {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
  border-top: 1.5px solid #e2e8f0;
  font-size: 11px;
  gap: 5px;
}
.pg-card-add-btn.pg-card-add-btn--no-inv:hover {
  background: #f1f5f9;
}

/* Dark mode */
.dark .pg-card.pg-card--no-inv {
  background: #1c1a10;
  border-color: #78350f;
}
.dark .pg-card.pg-card--no-inv:hover {
  border-color: #d97706;
  box-shadow: 0 4px 18px rgba(217, 119, 6, 0.15);
}
.dark .pg-card-badge-no-inv {
  color: #fbbf24;
  background: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.3);
}
.dark .pg-card-add-btn.pg-card-add-btn--no-inv {
  background: #1e293b;
  color: #475569;
  border-top-color: #334155;
}

/* ── Empty state ── */
.pg-empty {
  padding: 40px 20px;
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  font-style: italic;
}

.pg-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 56px 32px;
  text-align: center;
}

.pg-empty-icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #94a3b8;
  margin-bottom: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.pg-empty-heading {
  font-size: 15px;
  font-weight: 700;
  color: #334155;
  margin: 0;
  letter-spacing: -0.01em;
}

.pg-empty-sub {
  font-size: 12.5px;
  color: #94a3b8;
  margin: 0;
  max-width: 240px;
  line-height: 1.5;
}

/* ═══════════════════════════════════════════════════════════
   Dark mode
   ═══════════════════════════════════════════════════════════ */
.dark .pg-section-title { color: #60a5fa; }

.dark .pg-card {
  background: #111827;
  border-color: #1e293b;
}
.dark .pg-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 18px rgba(59, 130, 246, 0.15);
}
.dark .pg-card-img-wrap { background: #1e293b; }

.dark .pg-card-name        { color: #e2e8f0; }
.dark .pg-card-barcode     { color: #64748b; }
.dark .pg-card-mrp         { color: #475569; }
.dark .pg-card-sp          { color: #4ade80; }
.dark .pg-card-price-single { color: #93c5fd; }

.dark .pg-card-add-btn          { background: #1d4ed8; }
.dark .pg-card-add-btn:hover:not(:disabled) { background: #1e40af; }
.dark .pg-card-add-btn:disabled { background: #1e3a5f; color: #60a5fa; }

.dark .pg-empty-icon    { background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%); color: #475569; }
.dark .pg-empty-heading { color: #94a3b8; }
.dark .pg-empty-sub     { color: #475569; }
.dark .pg-empty         { color: #475569; }

/* ── Product detail info button — overlaid top-right of the image ── */
.pg-card-info-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.88);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  padding: 0;
  transition: background 0.15s, color 0.15s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.14);
}
.pg-card-info-btn:hover {
  background: #eff6ff;
  color: #2a71ff;
}
.dark .pg-card-info-btn {
  background: rgba(30,37,56,0.88);
  color: #94a3b8;
}
.dark .pg-card-info-btn:hover {
  background: rgba(42,113,255,0.18);
  color: #60a5fa;
}

/* ── Clickable tile body (image + text) — opens product detail drawer ── */
.pg-card-clickable {
  display: flex;
  flex-direction: column;
  flex: 1;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}
.pg-card-clickable:hover .pg-card-name {
  color: #2a71ff;
}
.pg-card-clickable:focus-visible {
  box-shadow: inset 0 0 0 2px #2a71ff;
}
.dark .pg-card-clickable:hover .pg-card-name {
  color: #60a5fa;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/searchBar/ProductGrid.css"],"names":[],"mappings":"AAAA;;gEAEgE;;AAEhE;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;AAChB;AACA,yBAAyB,gCAAgC,GAAG,WAAW,EAAE;AACzE,yBAAyB,iCAAiC,GAAG,WAAW,EAAE;AAC1E,yBAAyB,gCAAgC,IAAI,WAAW,EAAE;;AAE1E,eAAe;AACf;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,cAAc;EACd,8CAA8C;EAC9C,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;EACjC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,qEAAqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;gEAEgE;AAChE,0BAA0B,cAAc,EAAE;;AAE1C;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,8BAA8B,cAAc,EAAE;;AAE9C,kCAAkC,mBAAmB,EAAE;AACvD,8CAA8C,mBAAmB,EAAE;AACnE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE,0BAA0B,6DAA6D,EAAE,cAAc,EAAE;AACzG,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;;AAE1C,uEAAuE;AACvE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,yCAAyC;EACzC,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,eAAe;EACf,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   ProductGrid — 3-column card grid for sidebar-driven views\n   ═══════════════════════════════════════════════════════════ */\n\n.pg-wrapper {\n  padding: 16px 20px 20px;\n}\n\n.pg-section-title {\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #2a71ff;\n  margin: 0 0 14px;\n}\n\n.pg-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n/* ── Card ────────────────────────────────────────────────── */\n.pg-card {\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  border: 1.5px solid #e2e8f0;\n  background: #ffffff;\n  overflow: hidden;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease;\n}\n.pg-card:hover {\n  border-color: #93c5fd;\n  box-shadow: 0 4px 18px rgba(42, 113, 255, 0.1);\n}\n\n/* ── Image container (relative so badges can overlay) ── */\n.pg-card-img-container {\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* ── Image / placeholder ── */\n.pg-card-img-wrap {\n  width: 100%;\n  height: 80px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #f1f5f9;\n}\n.pg-card-img-wrap--default {\n  /* background is set inline via avatarBg */\n}\n.pg-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* ── Type indicator badges (overlay on image bottom-left) ── */\n.pg-card-badges {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  right: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  pointer-events: none;\n}\n.pg-card-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 2px 5px;\n  border-radius: 4px;\n  letter-spacing: 0.02em;\n  backdrop-filter: blur(4px);\n  line-height: 1;\n}\n.pg-card-badge--scale  { background: rgba(217,119,6,0.88);  color: #fff; }\n.pg-card-badge--bundle { background: rgba(99,102,241,0.88);  color: #fff; }\n.pg-card-badge--batch  { background: rgba(5,150,105,0.88);   color: #fff; }\n\n/* ── Body ── */\n.pg-card-body {\n  padding: 8px 10px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n.pg-card-name {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 2.7em;\n}\n\n/* Barcode */\n.pg-card-barcode {\n  font-size: 10px;\n  color: #64748b;\n  font-family: \"Courier New\", Courier, monospace;\n  letter-spacing: 0.04em;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Prices */\n.pg-card-prices {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin-top: 2px;\n}\n\n/* MRP with strikethrough — only shown when SP differs */\n.pg-card-mrp {\n  font-size: 10.5px;\n  color: #94a3b8;\n  text-decoration: line-through;\n}\n\n/* Selling price — highlighted when discounted */\n.pg-card-sp {\n  font-size: 12px;\n  font-weight: 700;\n  color: #16a34a;\n}\n\n/* Single price (MRP === SP or no SP) — shown without strikethrough */\n.pg-card-price-single {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1e40af;\n}\n\n/* ── Add to cart button ── */\n.pg-card-add-btn {\n  width: 100%;\n  padding: 8px 6px;\n  background: #2a71ff;\n  color: #fff;\n  font-size: 11.5px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  transition: background 0.15s ease;\n  flex-shrink: 0;\n  margin-top: auto;\n}\n.pg-card-add-btn:hover:not(:disabled) {\n  background: #1d5fd6;\n}\n.pg-card-add-btn:disabled {\n  background: #93c5fd;\n  cursor: default;\n}\n.pg-card-add-btn--success {\n  background: #10b981 !important;\n  cursor: default;\n}\n.pg-card-add-btn--error {\n  background: #ef4444 !important;\n  cursor: default;\n  font-size: 10.5px;\n}\n\n/* ── No-inventory card tint ── */\n.pg-card.pg-card--no-inv {\n  border-color: #fde68a;\n  background: #fffdf5;\n}\n.pg-card.pg-card--no-inv:hover {\n  border-color: #fbbf24;\n  box-shadow: 0 4px 18px rgba(245, 158, 11, 0.1);\n}\n\n/* ── Out-of-stock but eligible to sell (has inward, zero stock) ── */\n.pg-card-badge-oos {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: #fff7ed;\n  color: #c2410c;\n  white-space: nowrap;\n  width: fit-content;\n  border: 1px solid #fed7aa;\n}\n.dark .pg-card-badge-oos {\n  background: #431407;\n  color: #fb923c;\n  border-color: #7c2d12;\n}\n\n/* ── Multi-batch inline badge (card body) ── */\n.pg-card-badge-multi-batch {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: #d1fae5;\n  color: #065f46;\n  white-space: nowrap;\n  width: fit-content;\n}\n.dark .pg-card-badge-multi-batch {\n  background: #064e3b;\n  color: #6ee7b7;\n}\n\n/* ── No-inventory badge (inside card body) ── */\n.pg-card-badge-no-inv {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 9.5px;\n  font-weight: 700;\n  color: #b45309;\n  background: #fef3c7;\n  border: 1px solid #fde68a;\n  border-radius: 999px;\n  padding: 2px 7px;\n  letter-spacing: 0.05em;\n  margin-top: 3px;\n}\n\n/* ── No-inventory ADD button variant ── */\n.pg-card-add-btn.pg-card-add-btn--no-inv {\n  background: #f1f5f9;\n  color: #94a3b8;\n  cursor: not-allowed;\n  border-top: 1.5px solid #e2e8f0;\n  font-size: 11px;\n  gap: 5px;\n}\n.pg-card-add-btn.pg-card-add-btn--no-inv:hover {\n  background: #f1f5f9;\n}\n\n/* Dark mode */\n.dark .pg-card.pg-card--no-inv {\n  background: #1c1a10;\n  border-color: #78350f;\n}\n.dark .pg-card.pg-card--no-inv:hover {\n  border-color: #d97706;\n  box-shadow: 0 4px 18px rgba(217, 119, 6, 0.15);\n}\n.dark .pg-card-badge-no-inv {\n  color: #fbbf24;\n  background: rgba(245, 158, 11, 0.15);\n  border-color: rgba(245, 158, 11, 0.3);\n}\n.dark .pg-card-add-btn.pg-card-add-btn--no-inv {\n  background: #1e293b;\n  color: #475569;\n  border-top-color: #334155;\n}\n\n/* ── Empty state ── */\n.pg-empty {\n  padding: 40px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.pg-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 56px 32px;\n  text-align: center;\n}\n\n.pg-empty-icon {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  color: #94a3b8;\n  margin-bottom: 6px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n}\n\n.pg-empty-heading {\n  font-size: 15px;\n  font-weight: 700;\n  color: #334155;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.pg-empty-sub {\n  font-size: 12.5px;\n  color: #94a3b8;\n  margin: 0;\n  max-width: 240px;\n  line-height: 1.5;\n}\n\n/* ═══════════════════════════════════════════════════════════\n   Dark mode\n   ═══════════════════════════════════════════════════════════ */\n.dark .pg-section-title { color: #60a5fa; }\n\n.dark .pg-card {\n  background: #111827;\n  border-color: #1e293b;\n}\n.dark .pg-card:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 4px 18px rgba(59, 130, 246, 0.15);\n}\n.dark .pg-card-img-wrap { background: #1e293b; }\n\n.dark .pg-card-name        { color: #e2e8f0; }\n.dark .pg-card-barcode     { color: #64748b; }\n.dark .pg-card-mrp         { color: #475569; }\n.dark .pg-card-sp          { color: #4ade80; }\n.dark .pg-card-price-single { color: #93c5fd; }\n\n.dark .pg-card-add-btn          { background: #1d4ed8; }\n.dark .pg-card-add-btn:hover:not(:disabled) { background: #1e40af; }\n.dark .pg-card-add-btn:disabled { background: #1e3a5f; color: #60a5fa; }\n\n.dark .pg-empty-icon    { background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%); color: #475569; }\n.dark .pg-empty-heading { color: #94a3b8; }\n.dark .pg-empty-sub     { color: #475569; }\n.dark .pg-empty         { color: #475569; }\n\n/* ── Product detail info button — overlaid top-right of the image ── */\n.pg-card-info-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 2;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255,255,255,0.88);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475569;\n  padding: 0;\n  transition: background 0.15s, color 0.15s;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.14);\n}\n.pg-card-info-btn:hover {\n  background: #eff6ff;\n  color: #2a71ff;\n}\n.dark .pg-card-info-btn {\n  background: rgba(30,37,56,0.88);\n  color: #94a3b8;\n}\n.dark .pg-card-info-btn:hover {\n  background: rgba(42,113,255,0.18);\n  color: #60a5fa;\n}\n\n/* ── Clickable tile body (image + text) — opens product detail drawer ── */\n.pg-card-clickable {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  cursor: pointer;\n  outline: none;\n  -webkit-tap-highlight-color: transparent;\n}\n.pg-card-clickable:hover .pg-card-name {\n  color: #2a71ff;\n}\n.pg-card-clickable:focus-visible {\n  box-shadow: inset 0 0 0 2px #2a71ff;\n}\n.dark .pg-card-clickable:hover .pg-card-name {\n  color: #60a5fa;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
